// A merchant account row exists from the moment onboarding starts in Business Manager; PayPal only
// supplies the payer ID once the merchant completes it.
export const getPayPalPayerIdLabel = (payerId: string | null): string =>
  payerId ?? 'Pending onboarding';

export const getPayPalTransactionsReadyLabel = (transactionsReady: boolean): string =>
  transactionsReady ? 'Ready' : 'Not ready';
